import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:"",
    loginDialogState: false,
    registerDialogState: false,
    demandDialogState: false,
    resourcesDialogState: false,
  },
  mutations: {
    SET_TOKEN ( state, data ) {
      state.token = data
    },
    SET_LOGIN_DIALOG_STATE ( state, data ) {
      state.loginDialogState = data
    },
    SET_REGISTER_DIALOG_STATE ( state, data ) {
      state.registerDialogState = data
    },
    SET_DEMAND_DIALOG_STATE ( state, data ) {
      state.demandDialogState = data
    },
    SET_RESOURCES_DIALOG_STATE ( state, data ) {
      state.resourcesDialogState = data
    },
  },
  actions: {
  },
  modules: {
  }
})
